import { getPage } from 'common/actions/apiAction';
import bootstrapSelector from 'common/selectors/bootstrapSelector';
import routingSelector from 'common/selectors/routingSelector';
import { getMinutesUntilStart } from 'lib/format';
import uniqBy from 'lodash/uniqBy';
import * as perf from 'lib/util/perf';

export const REQUEST_SCHEDULE_MODULE_DATA = 'REQUEST_SCHEDULE_MODULE_DATA';
export const RECEIVE_SCHEDULE_MODULE_DATA = 'RECEIVE_SCHEDULE_MODULE_DATA';
export const SCORE_SCHEDULE_MODULE_DATA = 'SCORE_SCHEDULE_MODULE_DATA';

function decayContentScoreWithTime(content) {
    const DECAY_THRESHOLD = 30; // minutes until start time
    const minutesUntilStart = getMinutesUntilStart(content);

    if (minutesUntilStart >= DECAY_THRESHOLD) {
        content.score -= minutesUntilStart;
    }
    return content;
}

function dedupeBucketContents(buckets = []) {
    return buckets.map((bucket) => {
        const dedupedContents = uniqBy(bucket.contents || [], 'name');
        bucket.contents = dedupedContents;
        return bucket;
    });
}

function scoreBucketsWithTime(buckets = []) {
    return buckets.map((bucket) => {
        const scoredContents = bucket.contents.map((content) => decayContentScoreWithTime(content))
            .sort((aContent, bContent) => {
                if (aContent.score > bContent.score) {
                    return -1;
                } else if (aContent.score < bContent.score) {
                    return 1;
                }
                return 0;
            });
        bucket.contents = scoredContents;
        return bucket;
    });
}

export function createReceiveScheduleModuleAction(name, buckets) {
    return {
        type: RECEIVE_SCHEDULE_MODULE_DATA,
        name,
        buckets,
        receivedTime: Date.now()
    };
}

export function fetchScheduleModule(langArg) {
    return (dispatch, getState) => {
        perf.markStart('fetchScheduleModule');
        const lang = langArg || undefined;
        const state = getState();
        const bootstrap = bootstrapSelector(state);
        const { scheduleModule = {} } = bootstrap;
        const { locationBeforeTransitions } = routingSelector(state);
        const { pathname = '' } = locationBeforeTransitions || {};
        let pageName = 'scheduleModule';
        Object.keys(scheduleModule).some((key) => {
            const paths = scheduleModule[key].paths;
            if (paths.some((path) => pathname.indexOf(path) > -1)) {
                pageName = key;
                return true;
            }
            return false;
        });
        dispatch({
            type: REQUEST_SCHEDULE_MODULE_DATA,
            requestedTime: Date.now()
        });

        return dispatch(getPage({ name: pageName, lang })).then((response = {}) => {
            const { page: { buckets = [] } = {} } = response;
            if (buckets.length > 0) {
                const timeScoredBuckets = dedupeBucketContents(scoreBucketsWithTime(buckets));
                dispatch(createReceiveScheduleModuleAction(pageName, timeScoredBuckets));
                perf.measureAndTime('fetchScheduleModule');
            }
        });
    };
}

export function completeScheduleModuleScoring(buckets) {
    return {
        type: SCORE_SCHEDULE_MODULE_DATA,
        buckets: buckets ? scoreBucketsWithTime(buckets) : undefined,
        receivedTime: Date.now()
    };
}

export function scoreScheduleModule() {
    return (dispatch) => dispatch(completeScheduleModuleScoring());
}



// WEBPACK FOOTER //
// ./app/common/scheduleModule/actions/index.js